// extracted by mini-css-extract-plugin
export var addressFields = "_hp-0";
export var animationContainer = "_hp-1";
export var footer = "_hp-2";
export var lineItems = "_hp-3";
export var modalContent = "_hp-4";
export var orderName = "_hp-5";
export var strong = "_hp-6";
export var warning = "_hp-7";